import { render, staticRenderFns } from "./AreaComponent.vue?vue&type=template&id=80865356&scoped=true"
import script from "./AreaComponent.vue?vue&type=script&lang=js"
export * from "./AreaComponent.vue?vue&type=script&lang=js"
import style0 from "./AreaComponent.vue?vue&type=style&index=0&id=80865356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80865356",
  null
  
)

export default component.exports